export const satangToBaht = (satang: number): number => {
  return satang / 100
}
